import {useEffect, useRef, useState} from "react";
import "./LoginSection.scss"
import Logo from "../../resources/images/logo.svg"
import GraphImage from "../../resources/images/graph.svg"
import {FaRegSurprise} from "react-icons/fa";


const LoginSection = () => {
    const FormRef = useRef()
    const [message, setMessage] = useState(null)
    const [emailError, setEmailError] = useState(null)
    const [passwordError, setPasswordError] = useState(null)
    const [loading, setLoading] = useState(false)
    const [restore, setRestore] = useState(false)
    const [msgType, setMsgType] = useState('info')
    const [restoreMessage, setRestoreMessage] = useState('Enter the e-mail address you used to register and we will send you an e-mail with the recovery link.')


    useEffect(() => {

    }, [emailError, passwordError])


    const doLogin = async (input) => {

        const response = await fetch(`${process.env.REACT_APP_BASE_API}/users/login/`, {
            method : 'POST',
            body   : JSON.stringify(input),
            headers: {
                'Accept'      : 'application/json',
                'Content-Type': 'application/json',
            }
        });


        const data = await response.json();

        if (response.ok) {
            if (typeof data.token == "string") {
                window.localStorage.setItem('_tkn', data.token);
                window.location.href = '/';
            }
        } else {
            setEmailError(data.email ? data.email : null)
            setPasswordError(data.password ? data.password : null)
            setMessage(data.message ? data.message : null)
        }

    }

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(FormRef.current);
        setLoading(true)

        if (!restore) {
            doLogin({
                email   : formData.get('email'),
                password: formData.get('password')
            }).then((response) => {
                setLoading(false)
            })
        } else {


            fetch(`${process.env.REACT_APP_BASE_API}/users/restore/${formData.get('email')}`, {
                method: 'GET'
            }).then((response) => {

                response.json().then((data) => {
                    setMsgType('success')
                    setRestoreMessage(data.message)
                })

                setLoading(false)

            })

        }


    }


    const handleViews = (event) => {
        setRestore(!restore)
    }


    return (
        <div className="Auth">
            <div>
                <div className="AuthContainer">
                    <div className="AuthForm">
                        <form ref={FormRef}>
                            <div className="AuthHeader">
                                <img src={Logo} className="logo"/>
                                <div className="product-name">
                                    Campaign
                                </div>
                                <div className="AuthImage">
                                    <img src={GraphImage}/>
                                </div>
                            </div>

                            {message && <div className="alert alert-warning">
                                <FaRegSurprise/> {message}
                            </div>}

                            {!restore && <>
                                <div className="form-group mb-3">
                                    <label>Email address:
                                        {emailError && <span className="error">{emailError}</span>}
                                    </label>
                                    <input name="email" type="email" className="form-control" placeholder="Type your email"/>
                                </div>
                                <div className="form-group">
                                    <label>Your password:
                                        {passwordError && <span className="error">{passwordError}</span>}
                                    </label>
                                    <input name="password" type="password" className="form-control" placeholder="***************"/>
                                </div>
                            </>}

                            {restore && <>
                                <div className={`alert alert-${msgType}`}>
                                    {restoreMessage}
                                </div>
                                {msgType != 'success' && <div className="form-group mb-3">
                                    <label>Email address:
                                        {emailError && <span className="error">{emailError}</span>}
                                    </label>
                                    <input name="email" type="email" className="form-control" placeholder="Type your email"/>
                                </div>}

                            </>}

                            <div className="form-group text-center">
                                <div className="trouble-text">

                                    {!restore && 'Having trouble logging in? '}
                                    {restore && 'Do you know the password? '}

                                    <a href="#" onClick={handleViews}>
                                        {!restore && 'Restore password'}
                                        {restore && 'Go to Login'}
                                    </a>
                                </div>
                                {!restore && <button disabled={loading} className={`btn btn-sm btn-primary ${loading ? 'loading' : ''}`} onClick={handleSubmit}>
                                    Sign In
                                </button>}

                                {restore && msgType != 'success' &&
                                <button disabled={loading} className={`btn btn-sm btn-primary ${loading ? 'loading' : ''}`} onClick={handleSubmit}>
                                    Restore password
                                </button>}
                            </div>
                        </form>
                    </div>
                </div>
                <div className="AuthFooter">
                    V0.8.2 Beta
                </div>
            </div>
        </div>
    )
}

export default LoginSection;